import { mutatorAction } from "satcheljs";
import { shiftRequestsPanelStore } from "../";

export default mutatorAction('SET_IS_SAVING', function setIsSavingInStore(isSaving: boolean) {
    shiftRequestsPanelStore().isSaving = isSaving;
});
